import { useMutation, useQuery } from "@1f/react-sdk";
import { getSignerList } from "../query/signatureQueries";
import { createSignerModel } from "../helpers/modelHelpers";
import { mutation_pollSessionStatus, mutation_postToArchive, mutation_startSignSession } from "../mutations/signatureMutations";

export const SignatureApi = () => {

    const apiGetSigners = useQuery(
        getSignerList,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiStartSignSession = useMutation(
        mutation_startSignSession,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiPollSignSession = useMutation(
        mutation_pollSessionStatus,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const postToArchive = useMutation(
        mutation_postToArchive,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )

    const GetSignerList = async (tenantId,aziendaId) => {
        try {
            let singerListResponse = await apiGetSigners.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId
            })
            if(singerListResponse && singerListResponse.data){
                return singerListResponse.data.data.getSignerList.map((item) => createSignerModel(item))
            }
        } catch (error) {
            throw new Error(`Errrore durante il recupero della lista dei firmatari per l'azienda ${aziendaId}` + error.message);
        }
    }
    const StartSignSession = async (allegatoId,aziendaId,signer,selectedSign,selectedSignature, options = {}) => {
        try {            
            const signatureType = selectedSignature?.signatureType || selectedSign?.signatureType || selectedSign?.type;
            let dataInput = {
                allegatoId: allegatoId,
                aziendaId: aziendaId,
                autoSendCCT: options.autoSendCCT ?? false,
                useSignatureTimestamp: options.useSignatureTimestamp ?? false,
                metadata : options.autoSendCCT ? options.metadata ?? {
                    cct : {
                        PeriodoRiferimentoAnno: "",
                        DataDocumento: "",
                        DataDocumentoAntiriciclaggio: "",
                        TipoDocumento: "",
                        CognomeNomeRiferimento: "",
                        CodiceFiscaleRiferimento: "",
                        FileType: "pdf"                        
                    },
                    document: {
                        nomeUTE: ""
                    }
                } : {},  
                signatureProcessName: signatureType,
                signers: [{
                    mobile: signer.completeNumber,
                    email: signer.email,
                    fiscalCode: signer.fiscalCode,
                    firstName: signer.firstName,
                    lastName: signer.lastName,
                    signatureDatasV1 : [
                        {
                            signatureType : signatureType === "FEQ con dispositivo fisico" ? "FSC" : signatureType === "FEQ remota" ? "otp" : signatureType === "FEA remota" ? selectedSign.identificationType : ""  
                        }
                    ]
                }],
                sendSignedDocumentToMail: true
            }
            let startSessionResponse = await apiStartSignSession.fetch({
                dataInput: dataInput
            })
            if(startSessionResponse && startSessionResponse.data){
                return startSessionResponse.data.data.startSignSession
            }
        } catch (error) {
            throw new Error(`Errore durante l'avvio della sessione di firma dell'allegato: ${allegatoId} per l'azienda ${aziendaId}` + error.message);
        }
    }
    const PollSessionStatus = async (tenantId,aziendaId) => {
        try {
            let pollSessionsResponse = await apiPollSignSession.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId
            })
            if(pollSessionsResponse && pollSessionsResponse.data){
                return pollSessionsResponse.data.data.pollSessionStatus
            }
        } catch (error) {
            throw new Error(`Errore durante il polling dello stato delle sessione di firma dell'azienda: ${aziendaId}` + error.message);
        }
    }
    const PostToArchive = async (dataInput) => {
        try {
            let postToArchiveResponse = await postToArchive.fetch({
                dataInput: dataInput
            })
            if(postToArchiveResponse && postToArchiveResponse.data){
                return postToArchiveResponse.data.data.postToArchive
            }
        } catch (error) {
            throw new Error(`Errore durante l'archiviazione dell'allegato` + error.message);
        }
    }

    return {
        GetSignerList,
        StartSignSession,
        PollSessionStatus,
        PostToArchive
    }
}

export default SignatureApi;